import React from 'react';

const AdminDashboard = () => <h3>Dashboard, to show stats</h3>;

export default AdminDashboard;
